<template>

  <div class="card-background">
      <div class="columns">

      <TournamentMenu :tournament="tournament" />

      <div class="column is-four-fifths-desktop is-four-fifths-tablet">

        <div v-if="tournament" class="tournament-events-container">
          <h2 class="has-text-weight-bold has-text-left is-size-3" style="margin-bottom: 30px;">{{ tournament.name }} - Events</h2>

          <b-table :data="tournament.events" :columns="tableColumns" v-if="tournament" @click="eventClick"></b-table>


          <div class="has-text-right" style="margin-top: 25px;">
            <router-link :to="'/tournaments/' + tournament.id + '/events/add'" class="button is-danger is-medium">Add event</router-link>
          </div>
        </div>

        <div v-if="!tournament">
          <b-loading />
        </div>


      </div>

    </div>
  </div>
</template>

<script>
  import TournamentMenu from '../components/TournamentMenu.vue';
  import TournamentDataMixin from '../mixins/TournamentDataMixin.js';

export default {
  mixins: [ TournamentDataMixin ],

  data: () => {
    return {
      tableColumns: [
        {field: 'id', label: '#'},
        {field: 'name', label: 'Name'},
        {field: 'entriesCount', label: 'Entries'},
        {field: 'type', label: 'Type'},
        {field: 'firstMatch', label: 'First match'},
        {field: 'progressStatus', label: 'Progress'},
      ]
    }
  },
  computed: {
    tournaments: function(){ return this.$store.state.tournaments; }
  },

  methods: {
    eventClick(event) {
      let tournamentId = this.$route.params.id;
      this.$router.push('/tournaments/' + tournamentId + '/events/' + event.id + '/draws');
    }
  },

  components: { TournamentMenu },
  name: 'tournament-events'
}
</script>



<style>
  div.tournament-events-container div.b-table tbody tr {
    cursor: pointer;
  }
</style>
